import _ from "lodash";

const ROUTERS = {
  SIGN_CONTRACT: "/sign-contract",
  NOT_FOUND: "/404",
};
export const screensEnum = _.mapValues(ROUTERS, (value, key) => key);

export default ROUTERS;
